import { Banner, BannerContent, Link } from "@salt-ds/core";
import { JSXElementConstructor, ReactElement } from "react";

interface InfoBannerComponentProps {
  message: ReactElement<any, string | JSXElementConstructor<any>>[];
  linkText?: string;
  linkHref?: string;
  className?: string;
}

const InfoBannerComponent = ({ ...props }: InfoBannerComponentProps) => {
  return (
    <Banner className={props.className}>
      <BannerContent>
        {props.message}
        {props.linkText && props.linkHref && (
          <Link href={props.linkHref}>{props.linkText}</Link>
        )}
      </BannerContent>
    </Banner>
  );
};

export default InfoBannerComponent;
